<template>
  <!--START HOME-->
  <section
    class="section bg-home home-half scroll-select"
    id="home"
    data-image-src="images/bg-home.jpg"
  >
    <div class="bg-overlay"></div>
    <div class="display-table">
      <div class="display-table-cell">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2 text-white text-center">
              <h1 class="home-title">
                Nós Ajudamos Startups a decolarem de vez
              </h1>
              <p class="padding-t-15 home-desc">
                Esqueça as inúmeras apresentações em simpósios e congressos na
                expectativa de conseguir investidores e capital. Tire do papel a
                sua ideia inovadora com a Startandu!
              </p>
              <p class="play-shadow margin-t-30 margin-l-r-auto">
                <a href="//vimeo.com/99025203" class="play-btn video-play-icon"
                  ><i class="mdi mdi-play text-center"></i
                ></a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wave-effect wave-anim">
      <div class="waves-shape shape-one">
        <div
          class="wave wave-one"
          style="background-image: url('images/wave-shape/wave1.png')"
        ></div>
      </div>
      <div class="waves-shape shape-two">
        <div
          class="wave wave-two"
          style="background-image: url('images/wave-shape/wave2.png')"
        ></div>
      </div>
      <div class="waves-shape shape-three">
        <div
          class="wave wave-three"
          style="background-image: url('images/wave-shape/wave3.png')"
        ></div>
      </div>
    </div>
  </section>
  <!--END HOME-->
</template>

<script>
"use strict";
export default {
  name: "HeroSection2",
  props: {}
};
</script>
